import { Home } from '@containers';
import { Icon } from '@components';

export default [
  {
    path: '/',
    icon: Icon.HomeOutlined,
    text: 'Início',
    match: /\/+$/,
    sider: true,
    component: Home,
    exact: true,
    secret: true,
  },
];
